// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RejectedMint } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Mint';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useRejectedMints2Step = (): TemplateHistory<RejectedMint> =>
  useTemplateHistory(RejectedMint);
